

























import { Component, Vue, Prop, Model } from 'vue-property-decorator';

@Component({})
export default class SideBar extends Vue {
    @Prop({ default: 260 }) width!: number;
    @Model('update:active') readonly active!: boolean;

    get parent(): string {
        // @ts-ignore
        return this.$refs.parentSidebar as string;
    }

    get cssRules() {
        return `
            <style>
                .parent-sidebar .vs-sidebar {
                    max-width: ${this.width}px;
                }
            </style>
        `;
    }
}
